import React, { useEffect, useState } from "react";
import axios from "axios";

const ProductList = () => {
    const [products, setProducts] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios
            .get("http://localhost:3000/api/products")
            .then((response) => setProducts(response.data))
            .catch((error) => {
                console.error("Failed to fetch products:", error);
                setError("Failed to load products");
            });
    }, []);

    return (
        <div className="product-list">
            <h2 className="page-title">All Products</h2>

            {error && <p className="error">{error}</p>}
            {products.length === 0 && !error ? <p>No products found.</p> : null}

            <div className="product-grid">
                {products.map((product) => (
                    <div key={product._id} className="product-card">
                        <img
                            src={`http://localhost:3000${product.images?.[0] || "/placeholder.jpg"}`}
                            alt={product.productName}
                            className="product-image"
                            onError={(e) => (e.target.src = "/placeholder.jpg")}
                        />
                        <div className="product-info">
                            <h3>{product.productName}</h3>
                            <div className="price-row">
                                <span className="price">
                                    ₹{Number(product.displayPrice ?? product.cost ?? product.price ?? 0).toLocaleString()}
                                </span>
                                {product.discountedPrice && (
                                    <span className="discounted">₹{product.discountedPrice}</span>
                                )}
                            </div>
                            <p className="product-description">{product.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductList;
